/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'timeline-acq': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" _fill="none" fill-rule="evenodd"><path pid="0" d="M16 8h-5v23h14V16"/><circle pid="1" cx="25" cy="7" r="6"/><path pid="2" d="M25 5v4M23 7h4M2 31h28M16 31v-8h4v8M11 18H6v12M15 18h6M15 14h4"/></g>'
  }
})
